import { dataFlag } from 'dls-icons-data'
import { createIcon } from '../common'

const IconFlag = /*#__PURE__*/createIcon(dataFlag)
export default IconFlag
